import React, { useEffect } from "react";

interface ToastProps {
  message: string;
  type?: "success" | "error" | "info";
  onClose: () => void;
  duration?: number;
}

const typeStyles = {
  success: "bg-emerald-50/90 text-emerald-800 border-emerald-200",
  error: "bg-amber-50/90 text-amber-800 border-amber-200",
  info: "bg-blue-50/90 text-blue-800 border-blue-200",
};

export const Toast: React.FC<ToastProps> = ({ message, type = "info", onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div className={`fixed top-4 left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 md:right-4 z-50 flex items-center gap-2 px-4 py-3 rounded-lg border shadow-lg backdrop-blur-sm max-w-sm w-[calc(100vw-2rem)] md:w-auto ${typeStyles[type]}`}>
      <span className="text-sm font-medium flex-1">{message}</span>
      <button onClick={onClose} className="ml-2 p-1 opacity-60 hover:opacity-100 transition-opacity shrink-0 rounded">
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};
